<template>
  <div class="rule-container"> 
    <div class="rule-header"> 
      
      <v-layout>

        <v-flex md2>
           <v-autocomplete
              clearable
              label="Drug"
              :items="Object.keys(drugs)"
              placeholder="Choose drug"
              v-model="three.drug_name"
              @change="splitDose"
            ></v-autocomplete>
        </v-flex>

         <v-flex md1>
          <v-text-field
            label="Dose"
            v-model="three.dose"
            @input="splitDose"
          ></v-text-field>
        </v-flex>

        <v-flex md1>
          <v-text-field
            label="N. Days"
            v-model="three.n_days"
            hint="x Cycle"
          ></v-text-field>
        </v-flex>

         <v-flex xs1 md1> 
            <v-text-field
              label="C. Percent. %"
              hint="Cycle"
              v-model="three.percentage_cycle"
            ></v-text-field>
        </v-flex>
        
        <v-flex xs1 md1> 
            <v-text-field
              label="R. Percent. %"
              hint="Reduction"
              v-model="three.percentage"
            ></v-text-field>
        </v-flex>

        <v-flex xs5 md5> 
          
          <div v-for="(dose, index) in three.format_doses" :key="index" style="float:left;font-size:0.8em;margin-left:10px;margin-top:20px;font-weight:600;color:green">
            + {{dose.qta}} of {{dose.dose}} mg
          </div>
          
        </v-flex>

        <v-flex xs1 md1 text-center> 
          <v-btn  small color="danger" @click="remove"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
        </v-flex>

      </v-layout>
       
    </div>
  </div>
</template>

<script>

import split_chunks from './helpers'

export default {
  name: "drug",

  props: ["three", "index", "drugs"],

  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    remove: function() {
      this.$emit("child-deletion-requested", this.index);
    },
    splitDose() {
      
      if (this.three.drug_name) {
        let doses = [...this.drugs[this.three.drug_name].doses.sort((a, b) => b - a)]

        let ret = []
        let min = 0

        for(let i = 0; i < doses.length; i++) {
          let sc = split_chunks(this.three.dose, doses)
          let tot = 0
          let qta = 0
          sc.forEach( el => {
            tot += (el.dose * el.qta)
            qta += el.qta
          })
          let rest = tot - this.three.dose
          // console.log("tot ", tot)
          // console.log("resto ", rest)
          // console.log("qta ", qta)
          ret[rest + (qta/100)] = sc
          min = min < rest + (qta/100) && min > 0 ? min :  rest + (qta/100)
          doses.shift()
        }
        
        console.log(  min)
        
        this.three.format_doses = ret[min]
      } else {
        this.three.format_doses = null
      }
    }
  },
  mounted() {
    //this.three.n_days = this.three.n_pieces;
  },
   watch: {
      three: {
        handler() {
        },
        deep: true
      }
    },
};
</script>
